export function getModelNameFromUrl(url = '') {
  if (url.includes('/models/')) {
    const splitUrl = url.split('/');
    const modelsIndex = splitUrl.indexOf('models');
    if (modelsIndex > -1) {
      // Model name should be 2 over from models index,
      // eg: `.../en/models/q4/q4-e-tron/2025/...`
      const maybeModelName = splitUrl[modelsIndex + 2];
      if (maybeModelName && maybeModelName.includes('.html') === false) {
        return maybeModelName;
      }
    }
  }
  return null;
}
